import { render, staticRenderFns } from "./TeamDailyScrums.vue?vue&type=template&id=37c39b04&scoped=true&"
import script from "./TeamDailyScrums.vue?vue&type=script&lang=js&"
export * from "./TeamDailyScrums.vue?vue&type=script&lang=js&"
import style0 from "./TeamDailyScrums.vue?vue&type=style&index=0&id=37c39b04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c39b04",
  null
  
)

export default component.exports